module.exports = __webpack_public_path__ + "static/zeami_book-0f83138da97f23afc726e0b624620dbc.jpg";